import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardMedia from '@mui/material/CardMedia';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import get from 'lodash/get';
import { useWatch, useFormContext } from 'react-hook-form';

import classnames from 'classnames';

import { source } from '../data';
import ImageUpload from './image-upload';

const StyledRoot = styled(Card)({
    position: 'relative',
});

const StyledImg = styled(CardMedia)({
    width: '100%',
    background: `
        linear-gradient(45deg, #f5f5f5 25%, transparent 25%),
        linear-gradient(-45deg, #f5f5f5 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #f5f5f5 75%),
        linear-gradient(-45deg, transparent 75%, #f5f5f5 75%)
    `,
    backgroundSize: '16px 16px',
    backgroundPosition: '0 0, 0 8px, 8px -8px, -8px 0px',
});

const LargeImagePreview = ({
    className, record, source: fieldSource, ..._props
}) => {
    const { control, setValue } = useFormContext();
    const fieldValue = useWatch({ name: fieldSource, control });

    const handleImageUploaded = useCallback((imageData) => {
        setValue(source.source, imageData.source);
        setValue(source.format, imageData.format);
        setValue(source.width, imageData.width);
        setValue(source.height, imageData.height);
        setValue(source.bytes, imageData.bytes);
    }, [setValue]);

    if (!fieldValue) return null;

    const imgClasses = classnames(className);

    return (
        <StyledRoot variant="outlined">
            <ImageUpload
                folder={get(record, source.folder)}
                onImageUploaded={handleImageUploaded}
            >
                <CardActionArea>
                    <Tooltip title="Drop an image to replace, or click to select it">
                        <StyledImg
                            className={imgClasses}
                            component="img"
                            image={fieldValue}
                        />
                    </Tooltip>
                </CardActionArea>
            </ImageUpload>
        </StyledRoot>
    );
};

LargeImagePreview.propTypes = {
    className: PropTypes.string,
    record: PropTypes.object.isRequired,
    source: PropTypes.string.isRequired,
};

export default LargeImagePreview;
